import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-badge",
  "use": "icon-badge-usage",
  "viewBox": "0 0 19 22",
  "content": "<symbol viewBox=\"0 0 19 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-badge\">\n<path d=\"M6.02273 10.2308L8.72727 12.9231L12.9773 7.15385M9.5 1L18 4.63636V15.5455L9.5 21L1 15.5455V4.63636L9.5 1Z\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/badge.svg
// module id = tKxo
// module chunks = 262